import { useState } from 'react'
import { preloadImage, useAsyncEffect } from 'utils'
import { fetchChannelByUsername } from '../../../../api/channels'
import resizeAvatar from '../../../../util/resize-avatar'
import { UsernameData } from '../types'

export function useUserData(username: string): [UsernameData | null, boolean] {
    const [data, setData] = useState<UsernameData | null>(null)
    const [loading, setLoading] = useState<boolean>(false)

    useAsyncEffect(async () => {
        setData(null)
        setLoading(false)

        if (username) {
            try {
                setLoading(true)

                const { user } = await fetchChannelByUsername(username)
                const avatar = resizeAvatar((user as any).avatar || user.avatar_url, 80)

                await preloadImage(avatar)

                setData({
                    avatar,
                    username,
                    verified: user.is_verified,
                })
                setLoading(false)
            } catch (err) {
                setLoading(false)
            }
        }
    }, [username])

    return [data, loading]
}
